<template>
  <validation-observer
    ref="form"
    #default="{ invalid }"
  >
    <b-modal
      :id="modalName"
      size="lg"
      ok-only
      :ok-title="$t('save')"
      :ok-disabled="submitSpinner || invalid"
      no-close-on-backdrop
      @ok="onSubmit"
      @hidden="hideModal"
    >
      <template #modal-title="{}">
        <span>
          {{ isUpdated ? $t("Update") : $t("Create") }}
        </span>
        <span v-if="isUpdated">{{ form.name }}</span>
      </template>
      <b-form>
        <b-row>
          <b-col
            md="6"
            cols="12"
          >
            <b-form-group
              :label="$t('Name')"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Name')"
                vid="name"
                rules="required"
              >
                <b-form-input
                  id="name"
                  v-model="form.name"
                  type="text"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('Name')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            md="6"
            cols="12"
          >
            <b-form-group
              :label="$t('Slug')"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Slug')"
                vid="slug"
                rules="required"
              >
                <b-form-input
                  id="mobile"
                  v-model="form.slug"
                  type="text"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('Slug')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            md="6"
            cols="12"
          >
            <b-form-group
              :label="$t('Level')"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Level')"
                vid="level"
              >
                <b-form-input
                  id="level"
                  v-model="form.level"
                  type="text"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('Level')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
          >
            <b-form-group
              :label="$t('Description')"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Description')"
                vid="description"
                rules="required"
              >
                <b-form-textarea
                  id="description"
                  v-model="form.description"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('Description')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
          >
            <b-form-group :label="$t('Permissions')">
              <validation-provider
                #default="{ errors }"
                :name="$t('Permissions')"
                vid="permissions_id"
                rules="required"
              >
                <v-select
                  v-model="form.permissions_id"
                  :options="additionalData.permissions"
                  :clearable="false"
                  multiple
                  label="name"
                  :reduce="_permission => _permission.id"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>

      </b-form>
      <template #modal-ok="{}">
        <span>
          <b-spinner
            v-if="submitSpinner"
            small
          />
          {{ $t("save") }}
        </span>
      </template>
    </b-modal>
  </validation-observer>
</template>

<script>
import { EditFormLayoutMixin, EditModalMixin } from '../../../../common/mixins/form'

export default {
  name: 'RolesEditModal',
  mixins: [EditFormLayoutMixin, EditModalMixin],
  data() {
    return {
      routeName: 'roles',
      modalName: 'modal-roles-edit',
      useRouteName: true,
      createAbleFields: [
        'name',
        'slug',
        'description',
        'level',
        'permissions_id',
      ],
    }
  },
}
</script>

<style scoped>

</style>
